import React from 'react';
import {
    GetFilteredAssetLoadManagements_getFilteredAssetLoadManagements as AssetLoadType,
} from '../../../types/schemaTypes';
import { NoResult, useLazyLoading, Loading } from '../../_common';
import AssetLoadItem from '../../ListItem/AssetLoadItem';
import './AssetLoadList.scss';

interface SelectedLoad {
    loadId: number | null;
}

interface LoadListProps {
    assetLoadList: any[];
    isLoading: boolean;
    isEndOfResults: boolean;
    entries: (any | null)[];
    onLoadMore: () => void;
    selectedLoads: SelectedLoad[];
    setSelectedLoads: (loadItems: SelectedLoad[]) => void;
    onClickAssign: (loadId: number) => void;
}

const LoadList = ({
    assetLoadList,
    isLoading,
    isEndOfResults,
    onLoadMore,
    selectedLoads,
    setSelectedLoads,
    onClickAssign,
}: LoadListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('assetloadList', isLoading, isEndOfResults, onLoadMore);
    const onLoadItemCheck = (checkedStatus: boolean, load: AssetLoadType): void => {
        let result: SelectedLoad[] = [];
        if (checkedStatus === true) {
            result = selectedLoads.concat({ loadId: load.loadId });
        } else if (checkedStatus === false) {
            result = selectedLoads.filter((item): boolean => item.loadId !== load.loadId);
        }

        setSelectedLoads(result);
    };

    const isLoadChecked = (load: AssetLoadType): boolean => {
        return selectedLoads.filter((item): boolean => item.loadId === load.loadId)[0] !== undefined;
    };

    if (isLoading) {
        return (
            <div className="LoadList-Loading">
                <Loading />
            </div>
        );
    }

    return (
        <div className="JobLoads-LoadList 123" id="assetloadList" onScroll={handleScroll}>
            {assetLoadList && assetLoadList.length === 0 ? (
                <NoResult isModal={false} />
            ) : (
                assetLoadList &&
                assetLoadList.map(
                    (load): React.ReactElement => {
                        return (
                            <AssetLoadItem
                                load={load}
                                key={load.loadId}
                                isChecked={isLoadChecked(load)}
                                onChange={(checkedStatus: boolean): void => onLoadItemCheck(checkedStatus, load)}
                                onClickAssign={onClickAssign}
                            />
                        );
                    },
                )
            )}
        </div>
    );
};

export default LoadList;
